import { actionTypes } from '../actions/cupons.action';
const initialState = {
    promotions: {
        data: []
    },
    promotion: {},
    error: {},
    success: false
}

const CuponsReducer = (state = initialState, { type, payload }) => {
    switch (type) {

    case actionTypes.INDEX:

        return { ...state, ...payload }

    case actionTypes.UPDATE:
        let index = state.promotions.data.findIndex(item => item.id === payload.id)
        state.promotions.data[index] = payload

        return {
            ...state,
            promotions: {
                ...state.promotions,
                data: [
                    ...[(index < 0) && payload],
                    ...state.promotions.data
                ]
            }
        }

    case actionTypes.DESTROY:
        return {
            ...state,
            promotions: state.promotions.filter(item => item.id !== payload)
        }

    case actionTypes.CHANGE:
        return {
            ...state,
            promotion: (payload === 'clear') ? {} : {
                ...state.promotion,
                ...payload
            }
        }

    case actionTypes.SUCCESS:
        return {
            ...state,
            success: payload
        }

    case actionTypes.ERROR:
        return {
            ...state,
            error: payload
        }

    default:
        return state
    }
}

export default CuponsReducer